import { render } from "./CardTwentyNine.vue?vue&type=template&id=72a1cf51"
import script from "./CardTwentyNine.vue?vue&type=script&lang=js"
export * from "./CardTwentyNine.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__